import { render } from "./ViewTitle.vue?vue&type=template&id=045827fd"
import script from "./ViewTitle.vue?vue&type=script&lang=js"
export * from "./ViewTitle.vue?vue&type=script&lang=js"

import "./ViewTitle.vue?vue&type=style&index=0&id=045827fd&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__